package com.fireavert.analytics.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class CreatePageViewResponse(val success: Boolean, val errorMessage: String)